import React from 'react';
import TasksList from './TasksList';

interface BookingTasksListProps {
  bookingId: number;
  bookingRefCode?: string;
  bookingTitle?: string;
  publicClientId?: number;
  publicCompanyId?: number;
}

/**
 * Wrapper component for displaying tasks related to a specific booking.
 * Uses TasksList in booking mode with booking-specific filters.
 */
export default function BookingTasksList(props: BookingTasksListProps) {
  return (
    <TasksList
      mode="booking"
      bookingId={props.bookingId}
      bookingRefCode={props.bookingRefCode}
      bookingTitle={props.bookingTitle}
      publicClientId={props.publicClientId}
      publicCompanyId={props.publicCompanyId}
      hideFilters={false}
      hideSettings={true}
    />
  );
}
